import { create } from 'zustand';

/**
 * Global open/close state for the login MODAL (we no longer have a dedicated
 * /login page). Any "Login" affordance — the public header button, the old
 * /login URL, or an auth guard catching an unauthenticated user — flips this on,
 * and a single <LoginModal/> mounted at the app root renders it.
 *
 * `redirectTo` is where to send the user after a successful sign-in (the page
 * they were trying to reach); null falls back to /home (RoleHome).
 */
interface LoginModalState {
  open: boolean;
  redirectTo: string | null;
  openLogin: (redirectTo?: string | null) => void;
  closeLogin: () => void;
}

export const useLoginModal = create<LoginModalState>((set) => ({
  open: false,
  redirectTo: null,
  openLogin: (redirectTo = null) => set({ open: true, redirectTo }),
  closeLogin: () => set({ open: false }),
}));
